import React, { Component } from 'react'

import style from './Grid.css'

class ResponsiveEmbed extends Component {
    render() {
        return (
            <div className={style['video-container']}>
                {this.props.children}
            </div>
        )
    }
}

export default ResponsiveEmbed


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Grid/ResponsiveEmbed.js